// extracted by mini-css-extract-plugin
export default {"root":"LearningPathSection_root__P7sS0"};